export const formatDate = value => {
  if (value) {
    const givingDate = new Date(value);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return givingDate.toLocaleDateString('de-CH', options)
  }
};

export const formatTime = value => {
  if (value) {
    return value.substring(0, 5)
  }
};

export const formatShortDate = (value, obj) => {
  if (value) {
    const givingDate = new Date(value);
    return givingDate.toLocaleDateString('de-CH', obj)
  }
};


export const twoDigits = value => {
  if (value < 0) return '00';
  if (value.toString().length <= 1) return `0${value}`;
  return value;
};
